import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { isLegacyRoute, extractCategoriesFromRouteParams } from "app/pages/industry-analysis/routes/routeUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

const { carbon } = colorsPalettes;

const Container = styled.div`
    height: 52px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 16px;
    border-top: 1px solid ${carbon[100]};
`;

export const TopPlayersWidgetCallToAction = () => {
    const { params } = useCurrentStateAndParams();

    // Apply smart category formatting for legacy routes
    let hrefParams: any = { ...params };

    if (isLegacyRoute("market_research_players")) {
        const categories = extractCategoriesFromRouteParams(params);
        if (categories.length > 0) {
            // Use categories as-is since V2 redirects handle everything
            hrefParams = { ...hrefParams, category: categories };
        }
    }

    const href = proNavigator.href("market_research_players", hrefParams);
    const label = translate("industry.research.market.performance.players.cta");
    const trackButtonClicked = () => {
        allTrackers.dispatchTrackEvent("Internal Link", "click", `${label || ""}`);
    };
    return (
        <Container>
            <a
                href={href}
                onClick={trackButtonClicked}
            >
                <Button
                    type="flat"
                    label={label}
                />
            </a>
        </Container>
    );
};
